<script lang="ts">
  import type { EditorBlock } from 'query-strapi-v4';
  import EditorJs from './EditorJs.svelte';

  export let block = undefined as EditorBlock;
</script>

{#if block && block.editor}
  <EditorJs editor={block.editor} />
{/if}
